import { classNames } from "@/utils/classNames";
import { RadioCardImage } from "@/components/RadioCardImage";
import {
  RadioCardOverlay,
  RadioCardTrack,
  PwaLink,
} from "@/components/RadioCardParts";

export function RadioCard({ radio, meta, isActive, isPlaying, isLoading, onClick }) {
  const isPlaceholder = !!radio.placeholder;
  // Si le flux est figé depuis trop longtemps (>5min — flag `stale` envoyé par le
  // backend), on bascule sur le logo radio plein cadre et on masque artist/title
  // (qui sont obsolètes). Évite d'afficher la même pochette album sur 2-3 morceaux
  // d'affilée quand l'Icecast upstream est en cache CDN.
  const stale = !!meta?.stale;
  const cover = stale ? radio.logo : (meta?.artwork || radio.logo);
  const artist = stale ? "" : (meta?.artist || "");
  const title = stale ? "" : (meta?.title || "");
  const hasTrack = !isPlaceholder && !!(artist || title);

  return (
    <button
      type="button"
      onClick={isPlaceholder ? undefined : onClick}
      disabled={isPlaceholder}
      data-testid={`radio-card-${radio.id}`}
      className={classNames(
        "rh-card",
        isActive && !isPlaceholder && "rh-card-active",
        isPlaceholder && "rh-card-placeholder"
      )}
      style={{ "--accent": radio.color }}
    >
      <div className="rh-card-art" style={{ background: radio.color }}>
        <RadioCardImage
          cover={cover}
          fallback={radio.logo}
          accent={radio.color}
          alt={radio.name}
          isPlaceholder={isPlaceholder}
        />
        {!isPlaceholder && (
          <RadioCardOverlay
            isActive={isActive}
            isPlaying={isPlaying}
            isLoading={isLoading}
          />
        )}
        {isPlaceholder && (
          <div className="rh-card-badge rh-card-badge-soon">Disponible</div>
        )}
      </div>

      <div className="rh-card-body">
        <div className="rh-card-header-row">
          <div className="rh-card-name" title={radio.name}>
            {isPlaceholder ? "VOTRE RADIO ICI" : radio.name}
          </div>
          {!isPlaceholder && <PwaLink radio={radio} />}
        </div>
        <div className="rh-card-track" title={`${artist} ${title}`}>
          <RadioCardTrack
            isPlaceholder={isPlaceholder}
            hasTrack={hasTrack}
            artist={artist}
            title={title}
            tagline={radio.tagline}
          />
        </div>
      </div>
    </button>
  );
}
